<template>
    <section id="theme_search_form_tour">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="theme_search_form_area">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="tour_search_form mt-4">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div class="flight_Search_boxed">
                                                <p>{{ $t('Destination') }}</p>
                                                <input type="text" :placeholder="$t('Riyadh')" readonly>
                                                <span></span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                                            <div class="form_search_date">
                                                <div class="flight_Search_boxed date_flex_area">
                                                    <div class="Journey_date">
                                                        <p>{{ $t('Check-in') }}</p>
                                                        <VueDatePicker v-model="date"
                                                            :enable-time-picker="false"
                                                            :min-date="departure_min_date"
                                                            :max-date="departure_max_date"
                                                            @update:model-value="handleDate"
                                                            :placeholder="$t('Select date')" />
                                                        <span class="departure_day"></span>
                                                    </div>
                                                    <div class="Journey_date">
                                                        <p>{{ $t('Check-out') }}</p>
                                                        <VueDatePicker v-model="arrival_date"
                                                            :enable-time-picker="false"
                                                            :min-date="arrival_min_date"
                                                            :max-date="arrival_max_date"
                                                            @update:model-value="arrivalHandleDate"
                                                            :placeholder="$t('Select date')" />
                                                        <span class="arrival_day"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <CountDropdownHotel />
                                        <div class="top_form_search_button">
                                            <button class="btn btn_theme btn_md" type="button">
                                                {{ $t('Search Hotel') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

import CountDropdownHotel from '@/components/hotel/CountDropdownHotel.vue'

export default {
    name: "Form",
    components: {
        CountDropdownHotel
    },
};
</script>